import { AutoScrollActivator, MouseSensor, SensorDescriptor, TouchSensor, TraversalOrder, useSensor, useSensors } from '@dnd-kit/core';

export const dndAutoScrollOptionsDefault = { activator: AutoScrollActivator.DraggableRect, order: TraversalOrder.ReversedTreeOrder };

export const defaultDndDelay: number = 250;

export const dndOverlayAnimationDefault = {
  duration: defaultDndDelay,
  easing: 'cubic-bezier(0.18, 0.67, 0.6, 1.0)',
};

export const DndSensors = (delay: number = defaultDndDelay, tolerance: number = 15): SensorDescriptor<any>[] => {
  return useSensors(
    useSensor(MouseSensor, { activationConstraint: { delay, tolerance } }),
    useSensor(TouchSensor, { activationConstraint: { delay, tolerance } })
    // useSensor(PointerSensor, { activationConstraint: { delay, tolerance } })
  );
};
